import React from "react";
import PropTypes from 'prop-types';

export default class AccountOption extends React.Component {

    static propTypes = {
        model: PropTypes.object,

        isSelected: PropTypes.bool,

        onClick: PropTypes.func
    }

    onClick = () => {
        if (this.props.onClick) this.props.onClick(this.props.model.id);
    }

    render() {
        const classes = Classes("row", "search-item", {
            'selected': this.props.isSelected,
        });

        return (
            <div className={classes} onClick={this.onClick}>
                <div className="cell">
                    <div className="ui5-ico-13 m-r-10 i5-crm-account"/>
                    <div className="ui5-txt-default max-w-250">{this.props.model.name}</div>
                </div>
            </div>
        )
    }
}